// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file location.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LocationStatus, LocationStatusJson, LocationType, LocationTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file location.proto.
 */
export const file_location: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.Location
 */
export type Location = Message<"raccoonai.Location"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.LocationType type = 4;
   */
  type: LocationType;

  /**
   * @generated from field: required uint64 owner_organization_id = 5 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.LocationStatus status = 6;
   */
  status: LocationStatus;

  /**
   * @generated from field: required double lon = 7;
   */
  lon: number;

  /**
   * @generated from field: required double lat = 8;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 9;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 10;
   */
  address: string;

  /**
   * @generated from field: optional string gis_link = 12 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * @generated from field: optional uint64 service_time = 13 [json_name = "service_time"];
   */
  serviceTime: bigint;
};

/**
 * @generated from message raccoonai.Location
 */
export type LocationJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.LocationType type = 4;
   */
  type?: LocationTypeJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 5 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.LocationStatus status = 6;
   */
  status?: LocationStatusJson;

  /**
   * @generated from field: required double lon = 7;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lat = 8;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 9;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 10;
   */
  address?: string;

  /**
   * @generated from field: optional string gis_link = 12 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * @generated from field: optional uint64 service_time = 13 [json_name = "service_time"];
   */
  service_time?: string;
};

/**
 * Describes the message raccoonai.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location, {jsonType: LocationJson}> = /*@__PURE__*/
  messageDesc(file_location, 0);

/**
 * @generated from message raccoonai.LocationCreate
 */
export type LocationCreate = Message<"raccoonai.LocationCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.LocationType type = 2;
   */
  type: LocationType;

  /**
   * @generated from field: optional uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required double lon = 4;
   */
  lon: number;

  /**
   * @generated from field: required double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 6;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 7;
   */
  address: string;

  /**
   * @generated from field: optional string gis_link = 8 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * @generated from field: optional uint64 service_time = 9 [json_name = "service_time"];
   */
  serviceTime: bigint;
};

/**
 * @generated from message raccoonai.LocationCreate
 */
export type LocationCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.LocationType type = 2;
   */
  type?: LocationTypeJson;

  /**
   * @generated from field: optional uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required double lon = 4;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lat = 5;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 6;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 7;
   */
  address?: string;

  /**
   * @generated from field: optional string gis_link = 8 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * @generated from field: optional uint64 service_time = 9 [json_name = "service_time"];
   */
  service_time?: string;
};

/**
 * Describes the message raccoonai.LocationCreate.
 * Use `create(LocationCreateSchema)` to create a new message.
 */
export const LocationCreateSchema: GenMessage<LocationCreate, {jsonType: LocationCreateJson}> = /*@__PURE__*/
  messageDesc(file_location, 1);

/**
 * @generated from message raccoonai.LocationUpdate
 */
export type LocationUpdate = Message<"raccoonai.LocationUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.LocationType type = 4;
   */
  type: LocationType;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 5;
   */
  status: LocationStatus;

  /**
   * @generated from field: optional double lon = 6;
   */
  lon: number;

  /**
   * @generated from field: optional double lat = 7;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 8;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 9;
   */
  address: string;

  /**
   * @generated from field: optional string gis_link = 10 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * @generated from field: optional uint64 service_time = 11 [json_name = "service_time"];
   */
  serviceTime: bigint;
};

/**
 * @generated from message raccoonai.LocationUpdate
 */
export type LocationUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.LocationType type = 4;
   */
  type?: LocationTypeJson;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 5;
   */
  status?: LocationStatusJson;

  /**
   * @generated from field: optional double lon = 6;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double lat = 7;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 8;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 9;
   */
  address?: string;

  /**
   * @generated from field: optional string gis_link = 10 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * @generated from field: optional uint64 service_time = 11 [json_name = "service_time"];
   */
  service_time?: string;
};

/**
 * Describes the message raccoonai.LocationUpdate.
 * Use `create(LocationUpdateSchema)` to create a new message.
 */
export const LocationUpdateSchema: GenMessage<LocationUpdate, {jsonType: LocationUpdateJson}> = /*@__PURE__*/
  messageDesc(file_location, 2);

/**
 * @generated from message raccoonai.LocationList
 */
export type LocationList = Message<"raccoonai.LocationList"> & {
  /**
   * @generated from field: repeated raccoonai.Location locations = 1;
   */
  locations: Location[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.LocationList
 */
export type LocationListJson = {
  /**
   * @generated from field: repeated raccoonai.Location locations = 1;
   */
  locations?: LocationJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.LocationList.
 * Use `create(LocationListSchema)` to create a new message.
 */
export const LocationListSchema: GenMessage<LocationList, {jsonType: LocationListJson}> = /*@__PURE__*/
  messageDesc(file_location, 3);

/**
 * @generated from message raccoonai.LocationRequest
 */
export type LocationRequest = Message<"raccoonai.LocationRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.LocationRequest
 */
export type LocationRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.LocationRequest.
 * Use `create(LocationRequestSchema)` to create a new message.
 */
export const LocationRequestSchema: GenMessage<LocationRequest, {jsonType: LocationRequestJson}> = /*@__PURE__*/
  messageDesc(file_location, 4);

/**
 * Unset means every disposal site; nearby_only limits them to the caller's
 * pickup-location area.
 *
 * @generated from message raccoonai.ListDisposalSitesRequest
 */
export type ListDisposalSitesRequest = Message<"raccoonai.ListDisposalSitesRequest"> & {
  /**
   * @generated from field: optional bool nearby_only = 1 [json_name = "nearby_only"];
   */
  nearbyOnly: boolean;

  /**
   * Organizations whose pickup locations bound nearby_only, each checked; empty means the caller's own.
   *
   * @generated from field: repeated uint64 organization_ids = 2 [json_name = "organization_ids"];
   */
  organizationIds: bigint[];
};

/**
 * Unset means every disposal site; nearby_only limits them to the caller's
 * pickup-location area.
 *
 * @generated from message raccoonai.ListDisposalSitesRequest
 */
export type ListDisposalSitesRequestJson = {
  /**
   * @generated from field: optional bool nearby_only = 1 [json_name = "nearby_only"];
   */
  nearby_only?: boolean;

  /**
   * Organizations whose pickup locations bound nearby_only, each checked; empty means the caller's own.
   *
   * @generated from field: repeated uint64 organization_ids = 2 [json_name = "organization_ids"];
   */
  organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ListDisposalSitesRequest.
 * Use `create(ListDisposalSitesRequestSchema)` to create a new message.
 */
export const ListDisposalSitesRequestSchema: GenMessage<ListDisposalSitesRequest, {jsonType: ListDisposalSitesRequestJson}> = /*@__PURE__*/
  messageDesc(file_location, 5);

/**
 * @generated from message raccoonai.LocationListRequest
 */
export type LocationListRequest = Message<"raccoonai.LocationListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.LocationType types = 2;
   */
  types: LocationType[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 3 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.LocationListRequest
 */
export type LocationListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.LocationType types = 2;
   */
  types?: LocationTypeJson[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 3 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.LocationListRequest.
 * Use `create(LocationListRequestSchema)` to create a new message.
 */
export const LocationListRequestSchema: GenMessage<LocationListRequest, {jsonType: LocationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_location, 6);

